import React from 'react'
import { Link } from 'gatsby'
import { navigate } from '@reach/router'
import styled from '@emotion/styled'
import { css } from '@emotion/react'
import GlobalCSS from 'src/components/GlobalCSS'
import SEO from 'src/components/seo'
import ContentsWrapper from 'src/components/atoms/wrappers/ContentsWrapper'
import BlogListItem from 'src/components/organisms/blog/BlogListItem'
import SubPageTopLayout from 'src/components/organisms/SubPageTopLayout'
import Header from 'src/components/organisms/Header'
import Footer from 'src/components/organisms/Footer'
import Tag from 'src/components/molecules/Tag'
import { useQueryStringTag } from 'src/utils/blog'

const BlogTemplate = ({
  title,
  description,
  pageTitle,
  pageHeading,
  allMarkdownRemark,
  topSectionElement,
  bottomSectionElement,
  location
}) => {
  const queryStringTag = useQueryStringTag(location)
  const url = location.pathname

  const allTags = allMarkdownRemark.group
    .filter(({ fieldValue }) => fieldValue)
    .sort((a, b) => {
      return b.totalCount - a.totalCount
    })

  const { edges } = allMarkdownRemark
  const filteredEdges = !queryStringTag
    ? edges
    : edges.filter(({ node }) =>
        node.frontmatter.tags.some(tag => tag === queryStringTag)
      )

  return (
    <>
      <SEO title={title} description={description} />
      <Container>
        <GlobalCSS />
        <Header />
        <SubPageTopLayout title={pageTitle} heading={pageHeading} />
        <ContentsWrapper>
          {topSectionElement}
          <TagList>
            {!queryStringTag ? (
              <Tag isHighlight>すべて</Tag>
            ) : (
              <Tag as={Link} to={url}>
                すべて
              </Tag>
            )}
            {allTags.map(({ fieldValue }) => {
              const props =
                fieldValue === queryStringTag
                  ? { isHighlight: true }
                  : {
                      onClick: () => navigate(`?tag=${fieldValue}`)
                    }

              return (
                <Tag key={fieldValue} {...props}>
                  {fieldValue}
                </Tag>
              )
            })}
          </TagList>
          <BlogList>
            {filteredEdges.map(({ node }) => {
              const { title, date, thumbnail, tags } = node.frontmatter
              const description = node.excerpt

              return (
                <Link
                  to={node.fields.slug}
                  key={node.id}
                  css={blogListItemLinkCss}
                >
                  <BlogListItem
                    title={title}
                    date={date}
                    thumbnail={thumbnail}
                    description={description}
                    tags={tags}
                  />
                </Link>
              )
            })}
          </BlogList>
          {bottomSectionElement}
        </ContentsWrapper>
        <Footer />
      </Container>
    </>
  )
}

const Container = styled.div`
  z-index: 0;
  position: relative;
  overflow: hidden;
`

const BlogList = styled.div`
  margin-bottom: 120px;
  & > *:not(:first-of-type) {
    margin-top: 50px;
  }
`

const blogListItemLinkCss = css`
  display: block;
  text-decoration: none;
`

const TagList = styled.div`
  text-align: center;
  margin: 40px 0;

  & > * {
    margin: 10px;
    cursor: pointer;
  }
  & > a {
    text-decoration: none;
  }
`

export default BlogTemplate
